import { CONFIG_BASE } from "../constants/configs";

export const EXPLORERS = CONFIG_BASE.explorer;

/**
 * The explorer saved in the settings, or the default (first) one when it is unknown on this chain
 */
export const getExplorer = (id) => EXPLORERS.find((explorer) => explorer.id === id) || EXPLORERS[0];

/**
 * Link to a transaction, address or block in an explorer
 * type: "tx" | "address" | "block"
 */
export const explorerUrl = (explorer, type, value) => `${explorer[type]}/${value}`;
